import React, { Component } from "react";
import axios from "axios";
import validator from "validator";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { Row, Column } from "styled-bootstrap-components";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import MediaQuery from 'react-responsive';

import SubmitButton from "./SubmitButton";
import theme from "../styled/theme";
import { HelpText } from "../styled";

import { drinks, desserts } from "../../../src/util/extras";
import Extra from "../ItemForm/Ingredient/Extra";
import { AppContext } from "../AppProvider";
import Errors from './Errors';

const normalizeApiBase = (base) => (base.endsWith("/") ? base.slice(0, -1) : base);

const getOrderApiBase = (appMode) => {
	const isRestaurant = appMode === "restaurant";
	if (isRestaurant) {
		const base =
			process.env.REACT_APP_PUBLIC_API_URL_RESTAURANTE ||
			process.env.REACT_APP_SERVER_URL_RESTAURANTE ||
			process.env.REACT_APP_PUBLIC_API_URL ||
			process.env.REACT_APP_SERVER_URL ||
			"https://restaurante.bambansushi.com/api";
		return normalizeApiBase(base);
	}
	const base =
		process.env.REACT_APP_PUBLIC_API_URL ||
		process.env.REACT_APP_SERVER_URL ||
		"https://bambansushi.com/api";
	return normalizeApiBase(base);
};

const renderExtraList = (props) => (
	<Extra
		key={props.data.key}
		id={props.data.key}
		data={props.data}
		image={props.data.key}
		sodas={props.sodas}
		juices={props.juices}
		setExtra={props.setExtra}
		showPrice={props.showPrice}
	/>
);

const ErrorMessage = styled.div`
	color: ${theme.colors.primary};
`;

const required = (value) => {
	if (!value.toString().trim().length) {
		// We can return string or jsx as the 'error' prop for the validated Component
		return <ErrorMessage>Requerido.</ErrorMessage>;
	}
};

const email = (value) => {
	if (!validator.isEmail(value)) {
		return <ErrorMessage>El correo {value} no es válido.</ErrorMessage>;
	}
};

const phone = (value) => {
	if (!validator.isMobilePhone(value, "en-US")) {
		return <ErrorMessage>El teléfono {value} no es válido.</ErrorMessage>;
	}
};

const Title = styled.h2`
	font-family: "Oneer";
	font-size: 2.25rem;
	line-height: 2.25rem;
	margin: 0;
	text-transform: uppercase;
	word-break: break-word;

	@media (max-width: 767px) {
		font-size: 2rem;
		line-height: 2rem;
	}
`;

const Label = styled.label`
	display: none;
`;

const StyledInput = styled(Input)`
	background: ${theme.colors.icecream};
	border: 1px solid ${theme.colors.whiter};
	border-radius: 8px;
	font-size: 1rem;
	padding: 1rem;
	width: 100%;
	box-sizing: border-box;
`;

const StyledTextarea = styled.textarea`
	background: ${theme.colors.icecream};
	border: 1px solid ${theme.colors.whiter};
	border-radius: 8px;
	font-size: 1rem;
	padding: 1rem;
	width: 100%;
	box-sizing: border-box;
`;

const StyledCheckbox = styled('label')`
	padding: 1rem 16px;
    display: inline-block;
    cursor: pointer;
    border-radius: 8px;
    width: 100%;
    display: flex;
    justify-content: space-between;
	align-items: center;
    background: #faf6f2;
    border: 1px solid #373535;
`

const initialErrors = {
	quantity: '',
	branch: ''
};

const BranchSelect = styled.select`
	background: ${theme.colors.icecream};
	border: 1px solid ${theme.colors.whiter};
	border-radius: 8px;
	font-size: 1rem;
	padding: 0.85rem 1rem;
	width: 100%;
	box-sizing: border-box;
`;

const BranchLabel = styled.label`
	display: block;
	font-weight: bold;
	margin-bottom: 0.5rem;
	color: ${theme.colors.grayDark};
`;

const BranchGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 0.75rem;
`;

const BranchCard = styled.button`
	background: ${(p) => (p.active ? theme.colors.primary : '#fff')};
	color: ${(p) => (p.active ? '#fff' : theme.colors.grayDark)};
	border: 2px solid ${theme.colors.primary};
	border-radius: 12px;
	padding: 0.85rem 1rem;
	text-align: left;
	cursor: pointer;
	box-shadow: ${(p) => (p.active ? '0 6px 12px rgba(0,0,0,0.12)' : 'none')};
	transition: all 0.15s ease;

	h4 {
		margin: 0 0 0.25rem;
		font-size: 1.1rem;
	}

	p {
		margin: 0;
		font-size: 0.9rem;
		line-height: 1.3;
		color: ${(p) => (p.active ? '#fff' : theme.colors.gray)};
	}

	&:hover {
		transform: translateY(-2px);
	}
`;

const QuickFillButton = styled.button`
	background: ${theme.colors.primary};
	border: none;
	border-radius: 8px;
	color: #fff;
	padding: 0.55rem 0.9rem;
	font-weight: bold;
	cursor: pointer;
	transition: transform 0.1s ease, box-shadow 0.1s ease;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
	}
`;



class CheckoutForm extends Component {

	state = {
		appMode: this.props.context.appMode,
		table: localStorage.getItem("mesa") || "",
		firstName: this.props.context.user.firstName,
		lastName: this.props.context.user.lastName,
		email: this.props.context.user.email,
		phone: this.props.context.user.phone,
		addressOne: this.props.context.user.addressOne,
		addressTwo: this.props.context.user.addressTwo,
		city: "Santo Domingo",
		neighborhood: this.props.context.user.neighborhood,
		takeout: this.props.context.user.takeout,
		comment: this.props.context.user.comment,
		extras: [],
		sodas: [],
		juices: [],
		isErrorsModalOpen: false,
		formErrors: initialErrors,
		formValid: true,
		disabledSubmitButton: false
	};

	closeErrorsModal = () => {
		this.setState({ isErrorsModalOpen: false });
	};

	handleFormChange = () => {
		const user = {
			table: this.state.table,
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			email: this.state.email,
			phone: this.state.phone,
			addressOne: this.state.addressOne,
			addressTwo: this.state.addressTwo,
			city: "Santo Domingo",
			neighborhood: this.state.neighborhood,
			takeout: this.state.takeout,
			comment: this.state.comment
		};

		this.props.addUserData(user);
	};

	setExtra = (data, indexSoda, val = null) => {
		let extras = JSON.parse(JSON.stringify(this.props.context.orderExtra));
		let index = extras.findIndex((o) => o.id === data.id);

		if (data.key === "refresco") {
			if (val) {
				let count = 0;
				let i = extras.findIndex((oe) => {
					if (oe.key === "refresco") {
						if (indexSoda === count) {
							return true;
						}
						count++;
					}
					return false
				});

				extras[i].title = val;
				extras[i].id = val;
			} else {
				if (!data.quantity) {
					let i;
					extras.findIndex((oe, index) => {
						if (oe.key === "refresco") {
							i = index
						}
						return false
					});
					extras.splice(i, 1);
				} else {
					extras = [...extras, data];
				}
			}
		} else if (data.key === "jugo") {
			if (val) {
				let count = 0;
				let i = extras.findIndex((oe) => {
					if (oe.key === "jugo") {
						if (indexSoda === count) {
							return true;
						}
						count++;
					}
					return false;
				});

				extras[i].title = val;
				extras[i].id = val;
			} else {
				if (!data.quantity) {
					let i;
					extras.findIndex((oe, index) => {
						if (oe.key === "jugo") {
							i = index;
						}
						return false;
					});
					extras.splice(i, 1);
				} else {
					extras = [...extras, data];
				}
			}
		} else {
			if (index !== -1) {
				if (data.quantity === 0) {
					extras.splice(index, 1);
				} else {
					extras[index].quantity = data.quantity;
				}
			} else {
				extras = [...extras, data];
			}
		}

		this.props.context.setExtraItem(extras);
	};

	handleInputChange = ({ target }) => {
		const { name, value } = target;
		if (name === "table") {
			localStorage.setItem("mesa", value);
		}
		this.setState(
			{
				[name]: value,
			},
			this.handleFormChange
		);
	};

	handleCheckboxChange = async ({ target }) => {
		const { name, checked } = target;
		this.setState(
			{
				addressOne: checked ? 'Take Out.' : '',
				addressTwo: checked ? 'Voy pa’ allá.' : '',
				neighborhood: checked ? 'Lo pasaré a buscar.' : '',
				[name]: checked,
			},
			this.handleFormChange
		);
	}

	fillTestData = () => {
		this.setState(
			{
				firstName: 'test',
				lastName: 'test',
				email: 'enmanuelpsy@gmail.com',
				phone: '8093999429',
				addressOne: 'Calle prueba 123',
				addressTwo: 'Apto 1',
				neighborhood: 'Sector prueba',
				city: 'Santo Domingo',
				takeout: true,
			},
			this.handleFormChange
		);
	};

	handleOrderSubmit = (context) => {
		const isRestaurant = context.appMode === "restaurant";
		if (!context.branch) {
			this.setState({
				formValid: false,
				isErrorsModalOpen: true,
				formErrors: Object.assign({}, initialErrors, {
					branch: 'Selecciona la sucursal antes de continuar.'
				})
			})
			return;
		}
		if (!isRestaurant && !this.state.takeout && context.total < 500) {
			this.setState({
				formValid: false,
				isErrorsModalOpen: true,
				formErrors: Object.assign({}, initialErrors, {
					quantity: 'Minimo de orden para delivery 500 pesos, completar la orden para continuar.'
				})
			})
			return;
		}

		this.setState({
			formValid: true,
			disabledSubmitButton: true
		})

		context.setLoadingTopBar(true)
		let data = {
			order: context.order,
			orderExtra: context.orderExtra,
			user: context.user,
			orderNumber: context.orderNumber,
			total: context.total,
			tax: context.tax,
			serviceFee: context.serviceFee,
			branch: context.branch
		}
		if (!isRestaurant) {
			data.deliveryAmount = context.deliveryAmount;
		} else {
			data.is_delivery = 0;
		}

		axios
			.post(`${getOrderApiBase(context.appMode)}/orden`, data)
			.catch((error) => {
				console.log(error)
				context.setLoadingTopBar(false)
				this.setState({
					disabledSubmitButton: false
				})
				// alert('error al procesar la orden')
			})
			.then(() => {
				context.setLoadingTopBar(false)
				localStorage.removeItem("orderBambanSushi")
				localStorage.removeItem("orderExtraBambanSushi")
				this.setState({
					disabledSubmitButton: false
				})
				context.insertContact(data)
				this.props.history.push("/ordenar/confirmacion");
			});

	};

	render() {
		const isRestaurant = this.state.appMode === "restaurant";
		const emailField = (
			<Column sm={6} mb="1rem">
				<div>
					<Label htmlFor="email">Correo electrónico:</Label>
					<StyledInput
						name="email"
						id="email"
						type="email"
						placeholder="Correo electrónico"
						value={this.state.email}
						onChange={this.handleInputChange}
						validations={[required, email]}
						required
					/>
				</div>
			</Column>
		);
		return (
			<Form>
				{!isRestaurant && (
					<Row>
						<Column sm={12} mb="1rem">
							<Column sm={12} mb="1rem">
								<Title>Selecciona tu sucursal</Title>
							</Column>
							<BranchGrid>
								{[
									{
										key: "BAMBAN_NACO",
										title: "BAMBAN NACO",
										note: "Cubriendo Serralles, Miraflores, Piantini, Paraiso, Fernandez, Julieta, El Vergel, Zona Universitaria, Gazcue, Arroyo Hondo, Los Pinos y to’ eso pa’ alláRiba!",
									},
									{
										key: "BAMBAN_BELLA_VISTA",
										title: "BAMBAN BELLA VISTA",
										note: "Cubriendo La Julia, La Feria, El Cacique, Evaristo, Quisqueya, El Millón, Los Prados, San Geronimo, La Castellana, Mirador Norte, Cacicazgos, Honduras y to’ eso pa’ alláBajo!",
									},
								].map((b) => (
									<BranchCard
										type="button"
										key={b.key}
										active={this.props.context.branch === b.key}
										onClick={() => this.props.context.setBranch(b.key)}
									>
										<h4>{b.title}</h4>
										<p>{b.note}</p>
									</BranchCard>
								))}
							</BranchGrid>
						</Column>
					</Row>
				)}
				{!this.state.formValid && (
					<Errors
						formErrors={this.state.formErrors}
						open={this.state.isErrorsModalOpen}
						onClose={this.closeErrorsModal}
						close={this.closeErrorsModal}
						closeOnDocumentClick
					/>
				)}
				<Row>
					{/* <Column sm={12} mb="1rem">
						<Title>Informacion de Contacto</Title>
						<QuickFillButton type="button" onClick={this.fillTestData}>
							Llenar datos de prueba
						</QuickFillButton>
					</Column> */}
					{/* {isRestaurant && (
						<Column sm={6} mb="1rem">
							<div>
								<Label htmlFor="table">Mesa:</Label>
								<StyledInput
									name="table"
									id="table"
									type="text"
									placeholder="Mesa"
									value={this.state.table}
									onChange={this.handleInputChange}
									validations={[required]}
									required
								/>
							</div>
						</Column>
					)} */}
					<Column sm={6} mb="1rem">
						<div>
							<Label htmlFor="firstName">Nombre:</Label>
							<StyledInput
								name="firstName"
								id="firstName"
								type="text"
								placeholder="Nombre"
								value={this.state.firstName}
								onChange={this.handleInputChange}
								validations={[required]}
								required
							/>
						</div>
					</Column>
					{!isRestaurant && (
						<Column sm={6} mb="1rem">
							<div>
								<Label htmlFor="lastName">Apellido:</Label>
								<StyledInput
									name="lastName"
									id="lastName"
									type="text"
									placeholder="Apellido"
									value={this.state.lastName}
									onChange={this.handleInputChange}
									validations={[required]}
									required
								/>
							</div>
						</Column>
					)}
					{!isRestaurant && emailField}
					{isRestaurant && (
						<MediaQuery maxDeviceWidth={767}>{emailField}</MediaQuery>
					)}
					{!isRestaurant && (
						<Column sm={6} mb="1rem">
							<div>
								<Label htmlFor="phone">#WhatsApp:</Label>
								<StyledInput
									name="phone"
									id="phone"
									type="phone"
									placeholder="#WhatsApp"
									value={this.state.phone}
									onChange={this.handleInputChange}
									validations={[required, phone]}
									required
								/>
							</div>
						</Column>
					)}
					{isRestaurant && (
						<Column sm={12} mb="1rem">
							<div>
								<Label htmlFor="comment">
									Indique de manera escrita si desea un plato extra ...
								</Label>
								<StyledTextarea
									name="comment"
									id="comment"
									placeholder="Indique de manera escrita si desea un plato extra ..."
									value={this.state.comment}
									onChange={this.handleInputChange}
									required
								/>
							</div>
						</Column>
					)}
				</Row>

				{!isRestaurant && (
					<Row>
						<Column sm={12} mb="1rem">
							<Title>Direccion de Entrega</Title>
						</Column>
						<Column sm={12} mb="1rem">
							<div>
								<Label htmlFor="addressOne">Calle y número:</Label>
								<StyledInput
									name="addressOne"
									id="addressOne"
									type="text"
									placeholder="Calle y número:"
									value={this.state.addressOne}
									onChange={this.handleInputChange}
									validations={[required]}
									required
								/>
							</div>
						</Column>
						<Column sm={12} mb="1rem">
							<div>
								<Label htmlFor="addressTwo">
									Edificio / Apartamento / Residencial:
								</Label>
								<StyledInput
									name="addressTwo"
									id="addressTwo"
									type="text"
									placeholder="Edificio / Apartamento / Residencial"
									value={this.state.addressTwo}
									onChange={this.handleInputChange}
									validations={[required]}
									required
								/>
							</div>
						</Column>
						<Column sm={6} mb="1rem">
							<div>
								<Label htmlFor="neighborhood">Sector:</Label>
								<StyledInput
									name="neighborhood"
									id="neighborhood"
									type="text"
									placeholder="Sector"
									value={this.state.neighborhood}
									onChange={this.handleInputChange}
									validations={[required]}
									required
								/>
							</div>
						</Column>
						<Column sm={6} mb="1rem">
							<div>
								<Label htmlFor="city">Ciudad:</Label>
								<StyledInput
									name="city"
									id="city"
									type="text"
									placeholder="Ciudad"
									value={this.state.city}
									onChange={this.handleInputChange}
									required
								/>
							</div>
						</Column>
						<Column sm={6} mb="1rem">
							<div>
								<StyledCheckbox htmlFor="takeout"> Take Out (Pasar a buscar)
									<input
										name="takeout"
										id="takeout"
										type="checkbox"
										defaultChecked={this.state.takeout}
										value={this.state.takeout}
										onChange={this.handleCheckboxChange}
										required
									/>
								</StyledCheckbox>

							</div>
						</Column>
					</Row>
				)}
				<AppContext.Consumer>
					{(context) => (
						<Row>
							{!(context.branch === "BAMBAN_BELLA_VISTA" && isRestaurant) && (
								<Column sm={6} mb="1rem">
									<Title>ELEGIR BEBIDA</Title>
									{JSON.parse(JSON.stringify(drinks)).map((data) => {
										let index;
										let sodas = [];
										let juices = [];
										if (data.key === "refresco") {
											context.orderExtra.forEach((oe) => {
												if (oe.key === "refresco") {
													sodas.push(oe);
												}
											});
											data.quantity = sodas.length;
										} else if (data.key === "jugo") {
											context.orderExtra.forEach((oe) => {
												if (oe.key === "jugo") {
													juices.push(oe);
												}
											});
											data.quantity = juices.length;
										} else {
											if (context.orderExtra) {
												index = context.orderExtra.findIndex(
													(oe) => {
														return oe.id === data.id;
													}
												);
												if (index !== -1) {
													data.quantity =
														context.orderExtra[
															index
														].quantity;
												}
											}
										}
										return renderExtraList({
											data,
											...this.props,
											showPrice: true,
											sodas: sodas,
											juices: juices,
											setExtra: this.setExtra,
										});
									})}
								</Column>
							)}
							<Column sm={6}>
								<Title>ELEGIR POSTRE</Title>
								{JSON.parse(JSON.stringify(desserts)).map((data) => {
									if (context.orderExtra) {
										let index = context.orderExtra.findIndex(
											(oe) => {
												return oe.id === data.id;
											}
										);
										if (index !== -1) {
											data.quantity =
												context.orderExtra[
													index
												].quantity;
										}
									}
									return renderExtraList({
										data,
										...this.props,
										showPrice: true,
										setExtra: this.setExtra,
									});
								})}
							</Column>
						</Row>
					)}
				</AppContext.Consumer>
				<Row>
					<Column sm={12}>
						<MediaQuery maxDeviceWidth={767}>
							<br></br>
						</MediaQuery>
						<SubmitButton
							lg
							disabled={this.state.disabledSubmitButton || !this.props.context.branch}
							id="checkout-button"
							type="button"
							bg="primary"
							color="white"
							width="100%"
							onClick={() =>
								this.handleOrderSubmit(this.props.context)
							}
							formValid={this.props.context.order.length >= 1}
						>
							{isRestaurant ? "Enviar Pedido" : "Checkout"}
						</SubmitButton>
						<HelpText>
							<FontAwesomeIcon icon={faInfoCircle} size="lg" />
							{isRestaurant ? (
								<>
									Al presionar el botón de Enviar Pedido tu orden será colocada para
									ser procesada y a la vez aperturada tu cuenta o agregada en caso
									de ya existir. El proceso de pago sería de manera ordinaria con
									nuestros camareros y puede ser en efectivo, transferencia o en
									tarjeta de crédito.
								</>
							) : (
								<>
									Al presionar el botón de checkout tu orden será colocada.
									Puedes decidir cómo pagar al momento que tu pedido
									llegue a la dirección indicada. Se tendrá a tu
									disposición un veriphone y/o los recursos necesarios
									para que puedas realizar tu pago en efectivo.
								</>
							)}
						</HelpText>
					</Column>
				</Row>
			</Form>
		);
	}
}

export default CheckoutForm;
